export const iconFontAwesomeSocialEnvelope = (
	<i className="fa-solid fa-envelope"></i>
);
